<mat-grid-list class="login-container" cols="4">
    <mat-grid-tile class="image-container" [colspan]="2">
        <img src="../../assets/login-bottle-logo.svg" height="100%" width="100%" />
    </mat-grid-tile>
    <mat-grid-tile class="button-container" [colspan]="2">

        <div class="button-wrapper-card">
            <div class="logo-wrapper">
                <img src="../../assets/landing-logo-group.svg" />
            </div>
            <mat-card class="login-card">
                <h3>PlanoPro tool</h3>
                <div class="login-button">
                    <mat-card class="red-mat-card" (click)="onLogin()">
                        Login
                    </mat-card>
                    <div>
                        <button mat-button class="grey-button">
                            <mat-icon>help_outline</mat-icon>
                            Support
                        </button>

                    </div>
                </div>

            </mat-card>
            <div class="logo-wrapper">
                <img src="../../assets/dplogo.png" height="60px" width="200px" />
            </div>
        </div>

    </mat-grid-tile>
</mat-grid-list>